<div id="gameInfo" class="routBase">
    <header>
        <div class="container">
            <a (click)="_location.back()" title="Go Back"><i class="fas fa-arrow-left"></i></a>
            <h5 *ngIf="gameCategoryName">{{ gameCategoryName }}</h5>
            <h5 *ngIf="!gameCategoryName">{{ 'global.othersGames' | translate }}</h5>
        </div>
    </header>

    <div class="container px-0 px-md-3">

        <div class="gameSlider">
            <div *ngIf="theGame" class="gameSlideThumb">
                <div class="gameDiscription clearfix">
                    <img src="{{ global.propConfs$?.proxyCachefly ? '/neo-cachefly' : 'https://lxneo.cachefly.net/m3/cache' }}/{{ theGame.id }}_55.jpg" [alt]="theGame.desc1">
                    <h6>{{ theGame.name }}</h6>
                    <p>{{ theGame.desc5 ? theGame.desc5 : theGame.desc6 }}</p>
                </div>
                <div class="gameStatus">
                    <div class="gameRank">
                        <span *ngFor="let star of [].constructor(theGame.rank)"><i class="fas fa-star"></i></span>
                    </div>
                    <div class="gameInteractions">
                    </div>
                </div>
                <button class="btn" (click)="playGame(theGame.catId, theGame.id)">{{ 'global.playNow' | translate }}</button>
            </div>

            <!-- SLICK SLIDER FOR GAMES -->
            <!-- <ngx-slick-carousel class="gameCarousel" #slickModal="slick-carousel" [config]="gameSlideConfig">
                <div ngxSlickItem *ngFor="let slideGame of gamesToSlider | slice:0:3" class="gameSlideThumb">
                    <div class="gameDiscription clearfix" [class.showInfo]="showGameInfo">
                        <img src="https://lxneo.cachefly.net/m3/cache/{{ slideGame.id }}_55.jpg" [alt]="slideGame.desc1">
                        <h6>{{ slideGame.name }}</h6>
                        <p (click)="showGameInfo = showGameInfo">{{ slideGame.desc5 ? slideGame.desc5 : slideGame.desc6 }}</p>
                    </div>
                    <div class="gameStatus">
                        <div class="gameRank">
                            <span *ngFor="let star of [].constructor(slideGame.rank)"><i class="fas fa-star"></i></span>
                        </div>
                        <div class="gameInteractions">
                        </div>
                    </div>
                    <button class="btn" (click)="playGame(slideGame.catId, slideGame.id)">{{ 'global.playNow' | translate }}</button>
                </div>
            </ngx-slick-carousel> -->
        </div>

        <div *ngFor="let category of relatedCategories$; let idx = index" class="gameGrid">

            <header class="px-3 py-1">
                <h6>{{ category.categoryName | translate }}</h6>
                <a (click)="true" routerLink="/category/{{category.categoryId}}" queryParamsHandling="merge" title="{{ 'global.viewAll' | translate }}">{{ 'global.viewAll' | translate }} <i class="fas fa-chevron-right"></i></a>
            </header>

            <main *ngIf="category" class="px-3 px-md-0" [ngClass]="{'scrollX gridSimilarGames': idx == 0}">

                <div *ngFor="let game of category.categoryMedia" (click)="routeTo(game.catId, game.id)" class="gameThumb p-2 px-xl-3">
                    <img src="{{ global.propConfs$?.proxyCachefly ? '/neo-cachefly' : 'https://lxneo.cachefly.net/m3/cache' }}/{{ game.id }}_55.jpg" [alt]="game.name">
                    <p>{{ game.name }}</p>
                    <div class="rankStars">
                        <span *ngFor="let star of [].constructor(game.rank)"><i class="fas fa-star"></i></span>
                    </div>
                </div>

            </main>

            <div *ngIf="!category.categoryMedia" class="contentLoader my-5">
                <span></span>
            </div>
            <h5 *ngIf="category.categoryMedia && category.categoryMedia.length <= 0" class="text-center my-5">{{ 'global.noContent' | translate }}</h5>

        </div>
    </div>

</div>